import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import classes from '../updater.module.css';

function UpdateSelectField({
    field,
    initialValue,
    onChange
}) {
    const [value, setValue] = useState(initialValue);
    const user = useSelector(state => state.user);

    return (
        <FormControl className={classes['form-control']}>
            <InputLabel id={`update-field__${field}__label`}>{field}</InputLabel>
            <Select
                labelId={`update-field__${field}__label`}
                id={`update-field__${field}`}
                className={classes['form-input']}
                value={value || ''}
                required
                onChange={handleValueChange}
            >
                <MenuItem value="">Blank (no value)</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                {user.isSupervisor && (
                    <MenuItem value="On Hold">On Hold</MenuItem>
                )}
                <MenuItem value="Ready">Ready</MenuItem>
            </Select>
        </FormControl>
    );

    function handleValueChange(e) {
        const val = e.target.value;
        setValue(val);
        onChange(val);
    }
}

UpdateSelectField.propTypes = {
    field: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default UpdateSelectField;
